import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NbButtonModule } from '@nebular/theme';
import { NgxPanZoomModule } from 'ngx-panzoom';
import { OrgChartDesignerModule } from './chart-designer/chart-designer.module';

import { OrgChartComponent } from './org-chart.component';

@NgModule({
  declarations: [
    OrgChartComponent
  ],
  imports: [
    CommonModule,
    NgxPanZoomModule,
    NbButtonModule,
    OrgChartDesignerModule,
  ],
  bootstrap: [OrgChartComponent],
  exports: [OrgChartComponent]
})
export class OrgChartModule { }
